import React from 'react';
import { Link } from 'react-router-dom';

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen w-full">
      
      {/* Left: 2/3 content area */}
      <div className="w-full md:w-2/3 flex flex-col relative bg-white">
        
        <Link 
          to="/login" 
          className="absolute -top-16 left-4 md:-top-7 md:left-3 flex items-center gap-2 cursor-pointer"
        >
          <img
            src="/icons/Highwatch_logo.svg"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/icons/Highwatch_logo.svg";
            }}
            alt="Corelink Logo"
            className="h-56 w-52 md:h-36 -ml-4"
            // style={{ filter: 'brightness(0) saturate(100%) invert(16%) sepia(32%) saturate(1408%) hue-rotate(188deg) brightness(91%) contrast(94%)' }}
          />
          {/* <span className="text-base md:text-lg font-semibold tracking-wide leading-tight">
            HIGHWATCH<br />AI
          </span> */}
        </Link>

        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md px-4">
            {children}
          </div>
        </div>
      </div>

      {/* Right panel */}
      <div className="hidden md:flex w-1/3 bg-[#1E1E2F] items-center justify-center">
        <div className="text-white flex items-center gap-6">
          <img
            src="/icons/Highwatch_logo.svg"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/icons/Highwatch_logo.svg";
            }}
            alt="Corelink Icon"
            style={{ filter: 'brightness(0) invert(1)' }} 
            className="h-64 w-auto md:h-72"
          />
          {/* <div className="text-left leading-none">
            <div className="text-3xl md:text-4xl font-bold tracking-wider">HIGHWATCH</div>
            <div className="text-3xl md:text-4xl font-bold tracking-wider">AI</div>
          </div> */}
        </div>
      </div>
    </div>
  );
}